import { render } from "./localization-details.vue?vue&type=template&id=53e6d576"
import script from "./localization-details.vue?vue&type=script&lang=js"
export * from "./localization-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__